import { usePage } from "@inertiajs/react";

type InterpolationValues = Record<string, string | number>;

export default function useTranslations(namespace?: string) {
  const { locale, translations } = usePage().props;

  function resolve(key: string, ns?: string): unknown {
    const parts = ns ? [...ns.split("."), ...key.split(".")] : key.split(".");
    let current: unknown = translations;
    for (const part of parts) {
      if (current == null || typeof current !== "object") return undefined;
      current = (current as Record<string, unknown>)[part];
    }
    return current;
  }

  function t(key: string, interpolations?: InterpolationValues): string {
    const value = resolve(key, namespace) ?? resolve(key);
    if (typeof value !== "string") return key;
    if (!interpolations) return value;

    return value.replace(/%\{(\w+)\}/g, (_, name: string) =>
      String(interpolations[name] ?? `%{${name}}`)
    );
  }

  function raw<T = unknown>(key: string): T | undefined {
    const value = resolve(key, namespace) ?? resolve(key);
    return value as T | undefined;
  }

  return { t, raw, locale };
}
